"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectSearchPageAddress = void 0;
var react_1 = require("react");
var SeoCleanUrlPrefixes_1 = require("../constants/SearchPageCategories/SeoCleanUrlPrefixes");
var useSelectSearchPageAddress = function (location, isPostCardClicked) {
    return react_1.useMemo(function () {
        if (SeoCleanUrlPrefixes_1.SeoCleanUrlPrefixes.filter(function (item) { return location.pathname.search(item) > -1; }) &&
            !isPostCardClicked) {
            var url = location.pathname.split('-');
            if (url.length &&
                SeoCleanUrlPrefixes_1.EXCEPTION_ADDRESSES.includes(url[url.length - 2])) {
                return url[url.length - 2] + '-' + url[url.length - 1];
            }
            return url.pop();
        }
    }, [location.pathname, isPostCardClicked]);
};
exports.useSelectSearchPageAddress = useSelectSearchPageAddress;
